// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AssemblyJig } from './assembly-jig';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AssemblyJigNote extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  assemblyJigId!: number;
  deleted?: Date;
  deletedBy?: string;
  notes?: string;
  scheduled!: Date;
  assemblyJig!: AssemblyJig;
}

